module.exports = __webpack_public_path__ + "img/hpd.0128cff0.png";